<div
  ng-controller="EmailController"
  class="flex h-[70vh] w-[50vw] min-w-96 max-w-[50rem] flex-col gap-2 rounded"
>
  <div class="flex items-center gap-3 bg-slate-100 px-4 pb-2 pt-2">
    @if (backButton()) {
      <button
        class="rounded-xs border border-slate-100 hover:border-french-blue-50 hover:bg-french-blue-50"
        (click)="backButtonPress()"
      >
        <svg-icon src="/assets/icons/general/chevron-left.svg" />
      </button>
    }
    <h1 class="truncate text-sm font-medium">New Email</h1>
  </div>
  <form [formGroup]="emailForm" class="mx-2 box-border flex grow flex-col px-2">
    <div class="flex" tabindex="0" (focus)="changeFocus('toEmailAddress')">
      <div class="flex grow items-center">
        <span class="mr-2.5 flex shrink-0 grow-0 items-center">To:</span>
        <ag1-chip
          placeholder="Enter email address"
          [validatorFn]="validateEmail"
          keyword="email"
          formControlName="toEmailAddresses"
          [searchList]="allEmailAddresses"
          [isParentFocused]="toEmailAddressFocus"
          class="w-[95%] grow"
          (chipsChange)="updateEmailList($event)"
        />
        @if (!isCCFieldExpanded) {
          <p-button
            size="small"
            label="Cc"
            severity="contrast"
            variant="text"
            (click)="expandCcField()"
          />
        }
      </div>
    </div>
    @if (isCCFieldExpanded) {
      <hr class="m-0 shrink-0" />
      <div class="flex" tabindex="1" (focus)="changeFocus('ccEmailAddress')">
        <div class="flex grow items-center">
          <span class="mr-2.5 flex shrink-0 grow-0 items-center">Cc:</span>
          <ag1-chip
            placeholder="Enter email address"
            [validatorFn]="validateEmail"
            formControlName="ccEmailAddresses"
            keyword="email"
            [searchList]="allEmailAddresses"
            [isParentFocused]="ccEmailAddressFocus"
            (chipsChange)="updateEmailList($event)"
            class="w-[95%] grow"
          />
        </div>
      </div>
    }
    <hr class="m-0 shrink-0" />

    <div class="flex" tabindex="2">
      <div class="flex grow">
        <label
          for="emailSubject"
          class="mr-2.5 flex shrink-0 grow-0 items-center"
          >Subject:</label
        >
        <input
          class="flex flex-1 border-none"
          type="text"
          formControlName="emailSubject"
          (focus)="changeFocus('subject')"
          id="emailSubject"
          placeholder=""
        />
      </div>
    </div>
    <hr class="m-0 shrink-0" />
    <textarea
      formControlName="emailBody"
      id="emailBody"
      rows="15"
      class="mb-2 flex max-h-[15vh] resize-none border-none focus:outline focus:outline-slate-100"
      tabindex="3"
      (focus)="changeFocus('textarea')"
    ></textarea>
    <div
      tabindex="4"
      (focus)="changeFocus('attachments')"
      class="flex max-h-80 overflow-auto"
    >
      <div class="grid grid-cols-1 justify-items-start gap-2">
        @for (item of attachments(); track item) {
          @if (item.filename) {
            <p-chip
              class="max-w-full"
              [removable]="true"
              (onRemove)="removeAttachment(item)"
            >
              <svg-icon src="/assets/icons/general/document-text.svg" />
              <span
                class="labels-medium-emphasis truncate text-text-common-contrast"
              >
                {{ item.filename }}
              </span>
              <span
                class="body-small shrink-0 text-nowrap text-text-common-base"
              >
                {{ checkForFinalInvoice(item.type) }}
              </span>
            </p-chip>
          }
        }
      </div>
      @if (!attachments()?.length) {
        <ag1-banner
          variant="error"
          [isDismissible]="false"
          message="At least 1 document should be attached to an email"
        />
      }
    </div>
  </form>
  <div class="mx-2 mb-2 flex h-12 px-2 pb-2">
    <p-button
      label="Send email"
      [disabled]="!emailForm.valid || !docIds.length"
      (click)="sendEmail()"
    />
  </div>
</div>
